import { useLang } from "../lib/i18n";
import { IMAGES } from "../lib/images";
import { Systems, ColourPalette } from "./Fenetres";

export default function Clotures() {
  const { t } = useLang();
  const c = t.cloturesPage.colours;
  return (
    <>
      <Systems s={t.cloturesPage.systems} images={IMAGES.cloturesPage.systems} swapTitle />
      <ColourPalette
        c={c}
        downloads={[
          { label: c.download, href: "/documents/ral-clotures.pdf" },
          { label: c.downloadCatalogue, href: "/documents/catalogue-clotures.pdf" },
        ]}
      />
    </>
  );
}
